import React from 'react';

import { useFormContext } from 'app/developer-v3/components/PartnerSupportForm/contexts/FormContext';
import { withAutoScroll } from 'app/developer-v3/components/PartnerSupportForm/components/AutoScroll';
import {
  CollapsedBlock,
  RadioBlock,
} from 'app/developer-v3/teams/team-technical-support-operations/get-help';

type Item = {
  label: string;
  value: string;
  shouldRender?: (any) => boolean;
};

type RadioProps = {
  actions: {
    answer: (any) => void;
    unanswer: () => void;
  };
  isCurrent: boolean;
  data: any;
  label: string;
  items: Item[];
  state: string;
};

const Radio = (props: RadioProps) => {
  const {
    actions: { answer, unanswer },
    isCurrent,
    data,
    label,
    items,
    state,
  } = props;

  const context = useFormContext();
  const { size } = context;

  if (!isCurrent) {
    const subtitle = (
      items.find(item => item.value === data) || { label: data }
    ).label;

    if (!subtitle) {
      unanswer();
      return null;
    }

    return (
      <CollapsedBlock
        isDimmed={state !== 'confirm'}
        onClickEdit={unanswer}
        size={size}
        title={label}
      >
        {subtitle}
      </CollapsedBlock>
    );
  }

  const renderedItems = items.filter(
    item => !item.shouldRender || item.shouldRender(context)
  );
  return (
    <RadioBlock
      items={renderedItems}
      onClick={({ value }) => answer(value)}
      size={size}
      title={label}
    />
  );
};

export default withAutoScroll(Radio);
